import { removeSpaceAfter } from '../helpers/stringutils';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import { CYOA_NETWORK_IDS } from '../config';

const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);

dayjs.extend(AdvancedFormat);

// Displays start, end and duration numbers - sectors and tours
export const renderDurationText = (payload, index, custom='') => {
  if(custom === ''){
      if(index === payload.length - 1) return 'End City';
      if(index === 0) return 'Start City';
      return payload[index].duration + ' nights';
  }else{
    return custom;
  }
}


// Display dates in any date format and show length - [updated]
export const renderDateText = (payload, index, dateFormat, startOrEnd = "") => {
  if(startOrEnd === ""){
     if(index === 0 || payload[index].transfer.end_departure_date === null){
        return dayjs(payload[index].transfer.date_for).format(dateFormat);
     }else{
       return dayjs(payload[index].transfer.start_arrival_date).format(dateFormat) + " - " + dayjs(payload[index].transfer.end_departure_date).format(dateFormat);
     }
   }else{
     if(startOrEnd === 'start') return dayjs(payload[index].transfer.start_arrival_date).format(dateFormat);
     if(startOrEnd === 'end') return (payload[index].transfer.end_departure_date === null) ? dayjs(payload[index].transfer.start_arrival_date).format(dateFormat) : dayjs(payload[index].transfer.end_departure_date).format(dateFormat);
   }
}


//Display the start and end location - [updated]
export const renderStartEndLocation = (index, alldata, type, multiLine = false) => {

  if(alldata[index] !== undefined){
    if(index !== alldata.length - 1){
      try{
        let addressOriginal, newAddress, multiLineAddress;
        addressOriginal = (type === "start") ? alldata[index].address : alldata[index+1].address;
        newAddress = addressOriginal.replace("__", "").replace("__", " - ");
        multiLineAddress = addressOriginal.replace("__", "").replace("__", " - ").split(" - ");
        return (!multiLine) ?  newAddress : multiLineAddress;
      }catch(e){}
    }
  }else{
    return ""
  }
}


//Display the start and end times - [updated]
export const renderTimeDate = (alldata, index, type) => {

  if(alldata[index].tour_id === CYOA_NETWORK_IDS['europe'].id || alldata[index].tour_id === CYOA_NETWORK_IDS['usa'].id){
      try{

          const arrivalDate = (alldata[index].transfer.start_arrival_date !== null) ? dayjs(alldata[index].transfer.start_arrival_date).format('Do MMMM YYYY') : "";
          const arrivalTime = (alldata[index].transfer.start_arrival_time !== null) ? alldata[index].transfer.start_arrival_time : "";

          const departDate = (alldata[index].transfer.end_departure_date !== null) ? dayjs(alldata[index].transfer.end_departure_date).format('Do MMMM YYYY') : "";
          const departureTime = (alldata[index].transfer.end_departure_time !== null) ? alldata[index].transfer.end_departure_time : "";

          if(type === "start"){
            return (arrivalTime === "") ? "" : arrivalDate + " at " + arrivalTime;
          }else{
            return (departureTime === "") ? "" : departDate + " at " + departureTime;
          }

      }catch(e){}
  }
  else{
    if(type === "start"){
      return dayjs(removeSpaceAfter(alldata[index].transfer.date_for)).format('Do MMMM YYYY') + " at " + alldata[index].transfer.start_arrival_time;
    }else{
      return dayjs(removeSpaceAfter(alldata[index].transfer.date_for)).add(alldata[index].duration, 'days').format('Do MMMM YYYY')  + " at " + alldata[index].transfer.end_departure_time;
    }
  }
}


//Helper - sectors with image and extra information
export const sectorWithImagesAndInfo = (props) => {

  for(let j = 0; j < props.sectors.length; j++){
    if(props.sectors[j].tour_id === CYOA_NETWORK_IDS['europe'].id || props.sectors[j].tour_id === CYOA_NETWORK_IDS['usa'].id){
      if(props.cities !== undefined){
        props.sectors[j].images = (_filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].images === null) ? "" : _filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].images;
        props.sectors[j].address = (_filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].address === null) ? "" : _filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].address.replace(/(\r\n\t|\n|\r\t)/gm,"");
      }
    }else{
      if(props.products !== undefined && Object.keys(props.products).length > 0){
        props.sectors[j].images =  (_filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].media === null) ? "" : _filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].media;
        props.sectors[j].startTime = (_filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].startTime === null) ? "" : _filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].startTime;
        props.sectors[j].endTime = (_filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].endTime === null) ? "" : _filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].endTime;
        props.sectors[j].address = (_filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].startDescription === null) ? "" : _filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].startDescription + ', ' + _filter(props.products, ['ctfl_id', props.sectors[j].product_ctfl_id])[0].locations[0].name;
      }
    }
  }

  return props.sectors;
}

//Number of accommodation night for cyoa tours and status - ok and TBC (Don't include products)
export const accommodationNights = (sectors) => {
  let numNight = 0;
  for(let i = 0; i < sectors.length; i++){
    if(Object.keys(sectors[i].accommodation).length > 0 && Object.keys(sectors[i].accommodation.bookings).length > 0){
      if(sectors[i].accommodation.bookings.total !== "0.00"){
        numNight +=  sectors[i].accommodation.num_nights;
      }
    }
  }
  return numNight;
}

//Price for accommodation night for for cyoa tours and status ok
export const accommodationPrice = (sectors, type=null) => {
  let price = 0;
  for(let i = 0; i < sectors.length; i++){
    if(Object.keys(sectors[i].accommodation).length > 0 && (sectors[i].accommodation.status === "OK" || sectors[i].accommodation.status === "TBC")){
      if(type === null || type === "dorm"){
        price +=  parseFloat(sectors[i].accommodation.rooms[0].quote_price);
      }
      if(type === "private"){
        price += (sectors[i].accommodation.rooms.length > 1) ? parseFloat(sectors[i].accommodation.rooms[1].quote_price) :  parseFloat(sectors[i].accommodation.rooms[0].quote_price);
      }
    }
  }
  return price;
}


//Check accomodation radio buttons have been modified
export const hasAccomodationChange = (sectors) => {
  let typesArr = [];
  for(let i = 0; i < sectors.length; i++){
    if(Object.keys(sectors[i].accommodation).length > 0 && Object.keys(sectors[i].accommodation.bookings).length > 0){
      typesArr.push(sectors[i].accommodation.bookings.type)
    }
  }
  return _filter(typesArr, (o) => { return o !== "default" }).length > 0 ? true : false;
}


//Check accomodation has only one room type
export const checkAccomodationRoomType = (sectors) => {
  let roomsArr = [];
  for(let i = 0; i < sectors.length; i++){
    if(Object.keys(sectors[i].accommodation).length > 0 && sectors[i].accommodation.rooms.length){
      roomsArr.push(sectors[i].accommodation.rooms.length);
    }
  }
  return roomsArr.indexOf(1) !== -1;
}

//check accomodation has mulitple room types 
export const checkAccomodationMultiRoomType = (sectors) => {
  let roomsArr = [];
  for(let i = 0; i < sectors.length; i++){
    if(Object.keys(sectors[i].accommodation).length > 0 && sectors[i].accommodation.rooms.length){
      roomsArr.push(sectors[i].accommodation.rooms.length);
    }
  }
  return _includes(roomsArr, 1) && _includes(roomsArr, 2);
}

//Get the network id for CYOA
export const getCyoaID = () =>{
  return (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug || parsed.destination === CYOA_NETWORK_IDS["usa"].name ) ? CYOA_NETWORK_IDS["usa"].id : CYOA_NETWORK_IDS["europe"].id ;
}

//Get the network name for CYOA (Europe / Usa)
export const getCyoaName = () =>{
  return (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug || parsed.destination === CYOA_NETWORK_IDS["usa"].name ) ? CYOA_NETWORK_IDS["usa"].name : CYOA_NETWORK_IDS["europe"].name ;
}


// WEBPACK FOOTER //
// ./src/helpers/cyoaHelper.js